















import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import AppLogo from './header/AppLogo.vue';
import SearchBar from './header/SearchBar.vue';
// import NotificationsDropdown from './header/NotificationsDropdown.vue';
import { CoreStateInterface } from '../interfaces/coreState';
import ProfileDropdown from './header/ProfileDropdown.vue';

@Component({
    name: 'app-header',
    components: {
      AppLogo,
      SearchBar,
      // NotificationsDropdown,
      ProfileDropdown,
    },
})
export default class AppHeader extends Vue {
  @State('core') public core!: CoreStateInterface;
  @Mutation('core/toggleSidebar') public toggleSidebar: any;

  get hidden() {
    return this.core.hideSidebar;
  }
}
